import script from './next.vue_vue&type=script&lang.mjs';
export { default } from './next.vue_vue&type=script&lang.mjs';
import { render } from './next.vue_vue&type=template&id=93fbb39e&lang.mjs';

script.render = render;
script.__file = "packages/components/pagination/src/components/next.vue";
//# sourceMappingURL=next.mjs.map
